export default "__VITE_ASSET__Br0PJfwz__"